import { DefaultError, UseMutationOptions, UseMutationResult, useMutation } from '@tanstack/react-query';
import { useDucatClient } from '@/context/DucatClientCtx';

import { QueryKeys } from '../query-keys';

import { quantaApi } from './quantaApi';

export interface QuantaReferralSetResponse {
  data: {
    code: string;
  };
}

type MutationOptionsParam = Omit<UseMutationOptions<QuantaReferralSetResponse, DefaultError, string>, 'mutationFn'>;

export const useQuantaReferralSet = (options?: MutationOptionsParam): UseMutationResult<QuantaReferralSetResponse, Error, string> => {
  const { quantaHeaders: headers } = useDucatClient();

  return useMutation({
    mutationKey: [QueryKeys.quantaReferralSet],
    mutationFn: async (code: string) => {
      const result = await quantaApi.post('/set/referralCode', { code }, { headers });

      return result.data;
    },
    retry: false,
    ...options,
  });
};
